module.exports = __webpack_public_path__ + "img/face-tongue-sweat.daf5c45b.svg";